import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "delayFields"]

  connect() {
    this.toggleDelayFields()
  }

  toggleDelayFields() {
    // Find the checked radio button
    const checkedRadio = this.radioTargets.find(radio => radio.checked)

    if (checkedRadio && checkedRadio.value === "true") {
      this.delayFieldsTarget.style.display = "block"
    } else {
      this.delayFieldsTarget.style.display = "none"
    }
  }

  toggle(event) {
    this.toggleDelayFields()
  }
}
